module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + this.brightness + '%)'
    })
  }, [_c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }, {
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Navigate previous page/chapter'
      }),
      expression: "{ html: 'Navigate previous page/chapter' }",
      arg: "top"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - this.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'right': (this.widthSize * 7) + 'px'
    })
  }, [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }, {
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Navigate next page/chapter'
      }),
      expression: "{ html: 'Navigate next page/chapter' }",
      arg: "top"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - this.widthSize) * 2 + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (this.widthSize * 7) + 'px'
    })
  }, [_vm._v("chevron_right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': this.widthSize + '%',
      'background-color': this.currentColor
    })
  }, [_c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: this.fontFamily,
    style: ({
      'font-size': this.fontSize + 'px',
      'columns': this.cols
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition
    }
  }, [_c('router-view', {
    staticClass: "view"
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b097ed5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reader.vue
// module id = 19
// module chunks = 0